import { useEffect } from "react";

const useScrollSync = (
  tableRef: React.RefObject<HTMLDivElement>,
  headerRef: React.RefObject<HTMLDivElement>
) => {
  useEffect(() => {
    const handleScroll = () => {
      if (tableRef.current && headerRef.current) {
        headerRef.current.scrollLeft = tableRef.current.scrollLeft;
      }
    };

    if (tableRef.current) {
      tableRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (tableRef.current) {
        tableRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [tableRef.current, headerRef.current]);
};

export default useScrollSync;
